import React, { useState } from "react";
import PropTypes from "prop-types";

import _ from "lodash";

import { useTranslation } from "react-i18next";

import { Confirm, Card, Button, Popup, Divider, List } from "semantic-ui-react";
import CollapsibleValues from "../../shared/CollapsibleValues";
import "./EditGroup.css"


const EventGroup = ({
  editable,
  groupProps,
  onEditClick,
  onRemoveClick,

}) => {
  const { t } = useTranslation();

  const [showConfirmDelete, setShowConfirmDelete] = useState(false);
  const computedName = groupProps.name;
  const {setShowEditEventGroup, setSelectedEventGroup} = onEditClick;

  return (
    Object.keys(groupProps).length === 0 ? null:
    <Card className="generic-group-card">
      <Confirm
        open={showConfirmDelete}
        onCancel={() => setShowConfirmDelete(false)}
        onConfirm={() => {
          onRemoveClick();
          setShowConfirmDelete(false);
          
        }}
        content={`Delete ${computedName}?`}
      />
      <Card.Content>
        <Card.Header>{computedName}</Card.Header>
        <br />
        {!_.isEmpty(groupProps.description) && (
          <>
            <span>{groupProps.description}</span>
            <Divider />
          </>
        )}
        <List divided relaxed className={"group-props"}>
          {Object.entries(groupProps)
            .filter(
              (entry) =>
                entry[0] !== "id" &&
                entry[0] !== "name" &&
                entry[0] !== "description" &&
                entry[0] !== "created_at"
            )
            .map((entry) => {
              const key = entry[0];
              const propertyData = entry[1];
              let displayValues;
              if (_.isArray(propertyData.values)) {
                displayValues = propertyData.values.map((value) =>
                  value === "All" || value === "all"
                    ? t("groupSettings.all")
                    : value
                );
              } else {
                displayValues =
                  propertyData.values === "All" || propertyData.values === "all"
                    ? t("groupSettings.all")
                    : propertyData.values;
              }

              const name = _.includes(
                [
                  "material_location",
                  "material_unitof_measure",
                  "material_type",
                ],
                key
              )
                ? t(`ordersTable.columns.${key}`)
                : propertyData.name;

              return (
                <List.Item key={key}>
                  <strong>{name}</strong>: <CollapsibleValues values={displayValues} />
                </List.Item>
              );
            })}
        </List>
      </Card.Content>
      <Card.Content extra>
        <div className="group-card-footer">
          {/* {eventGroupButton(groupProps)} */}
          <Popup
            trigger={
              <Button
                disabled={!editable}
                basic
                icon="pencil"
                onClick={() => {
                  setShowEditEventGroup(true)
                  setSelectedEventGroup(groupProps)
                  // onEditClick
                }}
              />
            }
            content={t("groupSettings.editGroup")}
          />
          <Popup
            trigger={
              <Button
                disabled={!editable}
                basic
                icon="close"
                onClick={() => setShowConfirmDelete(true)}
              />
            }
            content={t("groupSettings.removeGroup")}
          />
        </div>
      </Card.Content>
    </Card>
  );
};

EventGroup.propTypes = {
  editable: PropTypes.bool,
  groupProps: PropTypes.object,
  onEditClick: PropTypes.func,
  onRemoveClick: PropTypes.func,
  onEditEventGroup: PropTypes.func,
  groups: PropTypes.array,
};

EventGroup.defaultProps = {
  editable: true,
  groupProps: {},
  onEditClick: _.noop,
  onRemoveClick: _.noop,
  onEditEventGroup: _.noop,
  groups: [],
};

export default EventGroup;
